module.exports = __webpack_public_path__ + "static/media/bg-drinks_dt.7ebeb4ac.jpg";